export default __webpack_public_path__ + "3208ed9.png";